<script setup>
import {ref} from "vue";
import searchService from "@/services/search.service";
import StartupsModal from "@/components/startups/StartupsModal.vue";

const {forTracker} = defineProps({
    forTracker: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['startupsAdded']);

const similarToId = ref(null);
const startups = ref([]);
const startupsModal = ref(null);
const showEmptyModal = ref(false);

async function getData() {
    let requestData = {};

    if (forTracker) {
        requestData.trackerId = similarToId.value;
    } else {
        requestData.companyId = similarToId.value;
    }

    const {data} = await searchService.getSimilar(requestData);
    startups.value = data;

    if (startups.value.length) {
        startupsModal.value.open();
    } else {
        showEmptyModal.value = true;
    }
}

function addedToTrackers() {
    getData();
    emit("startupsAdded");
}

function open(id) {
    similarToId.value = id;
    getData();
}

defineExpose({
    open
});
</script>

<template>
    <div>
        <StartupsModal
            ref="startupsModal"
            :startups="startups"
            :tracker-id="forTracker ? similarToId : null"
            @addedToTrackers="addedToTrackers"
        />

        <b-modal v-model="showEmptyModal" modal-class="modal-w-md" hide-footer title="Similar startups">
            <div class="p-4 text-center">
                <p class="no-similar">No similar startups were found.</p>
                <b-button class="button" @click="showEmptyModal = false">Close</b-button>
            </div>
        </b-modal>
    </div>
</template>

<style scoped>

</style>
